import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useSubscriptionItem} from '../hooks/useSubscriptionItem.ts';
import {useSubscriptionItemsSelection} from '../hooks/useSubscriptionItemsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';

import {useSubscriptionItems} from "../hooks/useSubscriptionItems.ts";


export const EditPage = () => {

    const {
        id: subscriptionId,
        subscriptionItemId
    } = useParams();

    if (typeof subscriptionId === 'undefined') {
        throw new Error('subscriptionId is required parameter');
    }

    const {fetchRecords} = useSubscriptionItems(subscriptionId || '');

    const {
        record: product,
        fetchRecord,
        updateRecord,
    } = useSubscriptionItem(subscriptionItemId || '');

    const {handleClearSelection} = useSubscriptionItemsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    useEffect(() => {
        fetchRecords();
    }, []);

    useEffect(() => {
        fetchRecord();
    }, [subscriptionId]);

    if (!product) {
        return <PlatformLoader message='Loading product...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={product.id}
            pageNavigation={<EditPageNavigation component={product}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={product}
                    />

                    {/*
                    <AccountsPage/>
*/}

                </Stack>
                :
                <RecordForm
                    record={product}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
